import React from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css"; // Font Awesome for icons

const TBDLoanHome = () => {
  return (
    <div className="dashboard-container">
      {/* Inline CSS */}
      <style>
        {`
          /* General Layout */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          body {
            font-family: 'Poppins', sans-serif;
            background: linear-gradient(135deg, #f3eae2, #e4d5c7);
            height: 100vh;
            overflow-y: auto;
            display: flex;
            justify-content: center;
            align-items: flex-start;
          }

          .dashboard-container {
            display: flex;
            width: 90%;
            max-width: 1200px;
            margin-top: 20px;
            background-color: white;
            border-radius: 12px;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
            overflow: hidden;
          }

          /* Sidebar */
          .sidebar {
            width: 260px;
            background: #2c3e50;
            color: white;
            padding: 20px;
            height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            transition: all 0.3s ease-in-out;
          }

          .sidebar h2 {
            text-align: center;
            font-size: 22px;
            font-weight: bold;
            border-bottom: 2px solid #ffffff66;
            padding-bottom: 15px;
            margin-bottom: 15px;
          }

          .sidebar ul {
            list-style-type: none;
            padding: 0;
          }

          .sidebar ul li {
            margin: 10px 0;
          }

          .sidebar ul li a {
            display: flex;
            align-items: center;
            padding: 12px;
            font-size: 16px;
            font-weight: bold;
            color: white;
            text-decoration: none;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
          }

          .sidebar ul li a i {
            margin-right: 12px;
          }

          .sidebar ul li a:hover,
          .sidebar ul li a.active-link {
            background: #1a252f;
            transform: scale(1.05);
          }

          /* Back Button */
          .back-button {
            width: 100%;
            padding: 14px;
            font-size: 16px;
            font-weight: bold;
            background: #c0392b;
            color: white;
            border: none;
            cursor: pointer;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
            display: block;
            text-align: center;
          }

          .back-button:hover {
            background: #a93226;
            transform: scale(1.02);
          }

          /* Content Area */
          .content {
            flex-grow: 1;
            padding: 40px;
            text-align: center;
            background-color: #f9f9f9;
            border-radius: 12px;
          }

          .content h2 {
            font-size: 28px;
            color: #2c3e50;
            margin-bottom: 20px;
            font-weight: bold;
          }

          .content p {
            font-size: 18px;
            color: #666;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .dashboard-container {
              flex-direction: column;
              width: 100%;
            }

            .sidebar {
              width: 100%;
              height: auto;
              text-align: center;
            }

            .sidebar ul li {
              display: flex;
              justify-content: center;
            }

            .sidebar ul li a {
              justify-content: center;
            }

            .content {
              padding: 20px;
            }

            .back-button {
              font-size: 14px;
              padding: 12px;
            }
          }
        `}
      </style>

      <aside className="sidebar">
        <h2>TBD Loan</h2>
        <nav>
          <ul>
            <li>
              <NavLink to="/tbd-loan/new" activeClassName="active-link">
                <i className="fas fa-file-alt"></i> New TBD Loan
              </NavLink>
            </li>
            <li>
              <NavLink to="/tbd-loan/receiver" activeClassName="active-link">
                <i className="fas fa-money-check-alt"></i> Loan Receiver
              </NavLink>
            </li>
            <li>
              <NavLink to="/tbd-loan/ledger" activeClassName="active-link">
                <i className="fas fa-book"></i> Loan Ledger
              </NavLink>
            </li>
            <li>
              <NavLink to="/tbd-loan/reports" activeClassName="active-link">
                <i className="fas fa-chart-pie"></i> Loan Reports
              </NavLink>
            </li>
            <li>
              <NavLink to="/tbd-loan/partnerwise-report" activeClassName="active-link">
                <i className="fas fa-user-friends"></i> Partnerwise Report
              </NavLink>
            </li>
            <li>
              <NavLink to="/tbd-loan/due-report" activeClassName="active-link">
                <i className="fas fa-file-invoice"></i> Due Report
              </NavLink>
            </li>
            <li>
              <NavLink to="/tbd-loan/partnerwise-due-report" activeClassName="active-link">
                <i className="fas fa-users"></i> Partnerwise Due Report
              </NavLink>
            </li>
            <li>
              <button onClick={() => window.history.back()} className="back-button">
                <i className="fas fa-arrow-left"></i> Back
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      <main className="content">
        <h2>Welcome to the TBD Loan Section</h2>
        <p>Select an option from the menu to proceed.</p>
      </main>
    </div>
  );
};

export default TBDLoanHome;
